module.exports = __webpack_public_path__ + "img/roi_high-profile_media.179abad9.jpg";